module.exports = __webpack_public_path__ + "static/media/Oswald-SemiBold.32e8a521.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Oswald-SemiBold.ttf
// module id = ./src/fonts/Oswald-SemiBold.ttf
// module chunks = 2